// UserDetailsModal.js

import React, { useContext, useEffect, useState } from 'react';
import { CorporateFare, Delete, Description, SettingsAccessibility } from '@mui/icons-material';

import { LoginContext } from '../../../App';
import { deleteUserDataByUUID, fetchUserOrganizations } from '../../../services/b2b-users-apiService';
import B2BPopUpForm from '../../b2b-common/B2BPopUpForm';
import B2BAccordion from '../../b2b-common/B2BAccordion';

import './UserDetailsModal.css';
import UserSystemFieldsTable from './UserSystemFieldsTable';
import UserMainFields from './UserMainFields';
import UserMembershipManagement from './UserMembershipManagement';
import { callAPIWhileSettingState } from '../../b2b-common/helpers';

function getUserOrganizations(loginData, user, setUserOrganizations) {
    const { accessToken } = loginData;
    fetchUserOrganizations(user.userUuid, accessToken)
        .then(response => {
            setUserOrganizations(response);
        })
        .catch(error => {
            console.log('error fetching user organizations: ', error);
        });
}

const UserDetailsModal = ({ open, user = {}, onUserUpdate, onClose }) => {
    const { loginData } = useContext(LoginContext);
    const [isDeleting, setIsDeleting] = useState(false);
    const [userOrganizations, setUserOrganizations] = useState([]);

    useEffect(() => {
        //console.log('UserDetailsModal useEffect user: ', user);
        if (user && user.userUuid) {
            getUserOrganizations(loginData, user, setUserOrganizations);
        }
    }, [user])

    const handleDeleteUser = () => {
        if (user && user.userUuid) {
            const paramsArray = [
                user.userUuid,
                loginData.accessToken
            ];
            callAPIWhileSettingState(deleteUserDataByUUID, paramsArray,
                isDeleting, onUserUpdate);
            onClose();
        }
        const { accessToken } = loginData;
        /* deleteUser(userUuid, accessToken); */
    }

    return (
        <B2BPopUpForm
            open={open}
            title={<span>User Details</span>}
            buttons={[
                {
                    label: 'Delete', isLoading: isDeleting,
                    confirm: true,
                    onConfirm: handleDeleteUser,
                    icon: <Delete />
                },
            ]}
            onClose={onClose}
        >
            <B2BAccordion
                title="System Fields"
                icon={<SettingsAccessibility />}
                defaultExpanded={false}
                className={'b2b-accordion-user-system-fields'}
            >
                {user && <UserSystemFieldsTable user={user} />}
            </B2BAccordion>
            <B2BAccordion
                title="Main User Fields"
                icon={<Description />}
                defaultExpanded={true}
                className={'b2b-accordion-user-fields'}
            >
                {user && <UserMainFields user={user} onUserUpdate={onUserUpdate} />}
            </B2BAccordion>

            <B2BAccordion
                title={`Membership (${user && userOrganizations ? userOrganizations.length : 0})`}
                icon={<CorporateFare />}
                defaultExpanded={false}
                className={'b2b-accordion-user-memberships'}
            >
                <UserMembershipManagement
                    user={user}
                    onUpdatedUserMembership={null}
                    onNewUserMembership={null}
                />
            </B2BAccordion>
        </B2BPopUpForm>
    );
};

export default UserDetailsModal;

